// BLOK — bold brutalist accordion. Thick 2px ink borders, hard offset
// shadows, uppercase type, and a fixed plus-morph icon in an accent square.
// Radius is clamped to at most 4px (min(var(--fq-radius), 4px)) so the
// brutalist edges survive any theme radius.
/** Blok always uses a plus icon (independent of the configured icon style)
 * so it can morph 45° on open via its own .fq-plus rule. */
const PLUS_SVG = '<svg class="fq-plus" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="blok-p-${it.idx}">
    <span class="fq-q">${it.q}</span>
    <span class="fq-box">${PLUS_SVG}</span>
  </button>
  <div class="fq-panel" id="blok-p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const blok = {
    id: 'blok',
    name: 'Blok',
    tag: 'Bold accordion',
    styleTag: 'Brutalist',
    description: 'Thick borders, hard shadows, uppercase type. An accordion with an opinion \u2014 for brands that would rather be loud than invisible.',
    layout: 'accordion',
    defaultAccent: '#d97706',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const blokRadius = `min(${ctx.v.radius}, 4px)`;
        const css = `
.FQM .fq-wrap{max-width:680px;margin:0 auto}
.FQM .fq-head{margin:0 0 28px}
.FQM .fq-title{margin:0;font-family:${ctx.v.head};font-size:42px;font-weight:800;line-height:1;letter-spacing:-0.02em;text-transform:uppercase;color:${ctx.v.ink}}
.FQM .fq-sub{margin:6px 0 0;font-size:15px;font-weight:500;line-height:1.55;color:${ctx.v.sub}}
.FQM .fq-list{display:flex;flex-direction:column;gap:14px}
.FQM .fq-acc{background:${ctx.v.card};border:2px solid ${ctx.v.ink};border-radius:${blokRadius};box-shadow:4px 4px 0 #0b2a46}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:16px 18px}
.FQM .fq-q{font-size:15px;font-weight:700;letter-spacing:0.02em;text-transform:uppercase;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-box{flex:0 0 auto;display:grid;place-items:center;width:28px;height:28px;border:2px solid ${ctx.v.ink};border-radius:${blokRadius};background:${ctx.v.accent}}
.FQM .fq-plus{width:12px;height:12px;color:#ffffff;transition:transform 0.32s cubic-bezier(0.4, 0, 0.2, 1)}
.FQM .fq-open .fq-plus{transform:rotate(45deg)}
.FQM .fq-a{padding:0 52px 18px 18px;font-size:15px;line-height:1.65;color:${ctx.v.sub}}
`;
        // Hard offset shadow flips to a light ghost on dark backgrounds.
        const cssDark = `
.FQM .fq-acc{box-shadow:4px 4px 0 rgba(255,255,255,0.25)}
`;
        return { html, css, cssDark };
    },
};
export default blok;
